(ns bp-clients.tv-app.utils.window
  "Namespace for accessing window native apis")

(defn size
  "Returns a map with :height :width sizes in px"
  []
  (let [window js/window
        doc-el js/document.documentElement
        body   js/document.body
        screen (when window (.-screen window))

        screen-h (when screen (.-height screen))
        screen-w (when screen (.-width screen))
        inner-h  (when window (.-innerHeight window))
        inner-w  (when window (.-innerWidth window))
        doc-el-h (when doc-el (.-clientHeight doc-el))
        doc-el-w (when doc-el (.-clientWidth doc-el))

        body-h (when body (.-clientHeight body))
        body-w (when body (.-clientWidth body))]
    {:height (or screen-h inner-h doc-el-h body-h)
     :width  (or screen-w inner-w doc-el-w body-w)}))

(defn set-interval
  "Sets an interval on the given function (f) with a
  given regular interval calls (ms, from milliseconds).
  Returns the id for clearing."
  [f ms]
  (when (and (fn? js/setInterval)
             (fn? f))
    (js/setInterval f ms)))

(defn clear-interval
  "Clears the interval by id"
  [id]
  (when (fn? js/clearInterval)
    (js/clearInterval id)))
